import { render } from "./NewPostView.vue?vue&type=template&id=352814e8"
import script from "./NewPostView.vue?vue&type=script&lang=js"
export * from "./NewPostView.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\gerardo\\source\\repos\\Dorapp Web\\Dorapp Web\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__